import React from "react";
import styles from "./Footer.module.css";

function Footer() {
  return (
    <div className={styles.container}>
      <h3>PI VideoGames: Oscar Arrieta Ramos - 2023</h3>
    </div>
  );
}

export default Footer;
